import React, { useState } from "react";
import Footer from "./Footer";
import Header from "./Header";
import Sidebar from "./Sidebar";

const Layout = ({ children, ...props }) => {
  // Toggle Start
  const [toggleLayout, setToggleLayout] = useState(false);
  const [unreadConversationCount, setUnreadConversationCount] = useState(0);
  const toggleLayoutAction = (value) => {
    setToggleLayout(value);
  };
  // Toggle End

  return (
    <>
      <div className={`wrapper ${toggleLayout === true ? "toggled" : ""}`}>
        <Sidebar
          toggleLayoutSidebar={toggleLayoutAction}
          unreadConversationCount={unreadConversationCount}
        />
        <Header
          toggleLayoutHeader={toggleLayoutAction}
          onUnreadConversationCountChange={setUnreadConversationCount}
        />
        <div className="page-wrapper">
          <div className="page-content-wrapper">
            <div className="page-content" {...props}>{children}</div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default Layout;
